import React from 'react';

const providerContext = React.createContext();

export default providerContext;